<div class="layout-wrapper layout-content-navbar">
    <div class="layout-container">
      <app-side-nav></app-side-nav>
      <div class="layout-page">
        <div class="container mt-4">

          <div>
            <button type="button" class="btn btn" (click)="goBack()" style="color: blue;" >
                <img src="assets/img/icons/back.png" alt="Back" style="width: 16px; height: 16px; margin-right: 5px; color: blue;"> Back
            </button>
        </div>

        <div class="d-flex justify-content-between align-items-center">
          <h2 class="mr-3">Users / View User</h2>
          <div class="d-flex align-items-center">
            <div class="status" style="margin-right: auto;">
              Status - <span class="text-success">{{ userData?.status }}</span>
            </div>
            <button [routerLink]="['/edit-user', userData?.user_id]" 
                    class="btn btn-dark ml-7" 
                    style="background-color: #2b124c;">
              Edit User
            </button>
          </div>
        </div>
        
          <div *ngIf="userData">
            <div class="card mt-3">
              <div class="card-body">
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#general">General</a>
                  </li>
                </ul>
                <div class="tab-content mt-3">
                  <div id="general" class="tab-pane active">
                    <div class="card mb-3">
                      <div class="card-header  text-white">Manager Details</div>
                      <div class="card-body manager-details">
                        <div class="row">
                          <div class="col-md-4"><strong>Manager Name</strong><br>{{ userData.manager_name }}</div>
                          <div class="col-md-4"><strong>Manager Code</strong><br>{{ userData.manager_code }}</div>
                          <div class="col-md-4"><strong>Site Location</strong><br>{{ userData.site_location }}</div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-4"><strong>Designation</strong><br>{{ userData.role }}</div>
                          <div class="col-md-4"><strong>Address</strong><br>{{ userData.site_address }}</div>
                        </div>
                      </div>
                    </div>
                    <br>
                    <div class="card mb-3">
                      <div class="card-header  text-white">Contact Details</div>
                      <div class="card-body contact-details">
                        <div class="row">
                          <div class="col-md-6"><strong>Mobile no</strong><br>{{ userData.mobile }}</div>
                          <div class="col-md-6"><strong>Email</strong><br>{{ userData.email }}</div>
                        </div>
                      </div>
                    </div>
                    <br>
                    <div class="card mb-3">
                      <div class="card-header text-white">Study Data</div>
                      <div class="card-body">
                        <div class="row mb-3">
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Search by name, mobile" [(ngModel)]="searchText" (input)="applyFilter()">
                          </div>
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Start Date" [(ngModel)]="startDateFilter" (input)="applyFilter()"
                              onfocus="(this.type='date')" onblur="(this.type='text')">
                          </div>
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Completion Date" [(ngModel)]="endDateFilter" (input)="applyFilter()"
                              onfocus="(this.type='date')" onblur="(this.type='text')">
                          </div>
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Filter by status" [(ngModel)]="statusFilter" (input)="applyFilter()">
                          </div>
                        </div>
                        <table class="table table-bordered">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Study Name</th>
                              <th>Site Location</th>
                              <th>Start Date</th>
                              <th>Completion Date</th>
                              <th>Study Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let study of filteredStudies; let i = index">
                              <td>{{ i + 1 }}</td>
                              <td>{{ study.study_name || 'N/A'}}</td>
                              <td>{{ study.site_location || 'N/A' }}</td>
                              <td>{{ study.date_assigned || 'N/A'}}</td>
                              <td>{{ study.completion_date || 'N/A' }}</td>
                              <td>{{ study.study_status || 'N/A'}}</td>
                              <td>
                                <div class="dropdown">
                                  <button type="button" class="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                    <i class="bx bx-dots-vertical-rounded"></i>
                                  </button>
                                  <div class="dropdown-menu">
                                    <a class="dropdown-item" href="javascript:void(0);" (click)="viewStudy(study.id)">
                                      <i class="bx bx-show-alt me-1"></i> View
                                    </a>
                                    <a class="dropdown-item" href="javascript:void(0);" (click)="editStudy(study.id)">
                                      <i class="bx bx-edit-alt me-1"></i> Edit
                                    </a>
                                    <a class="dropdown-item" href="javascript:void(0);" (click)="setStudyInactive(study.id)">
                                      <i class="bx bx-trash me-1"></i> Inactive
                                    </a>
                                  </div>
                                </div>
                              </td>
                              
                              
                              
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!userData" class="text-center">
            <div class="spinner-border text-success" role="status">
              <span class="sr-only"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  